<template>
  <!-- <div class="login-container">
    <div class="login-box">
      <div class="logo-img" />
      <div class="err-msg">
        {{ showErrorInfo }}
      </div>
      <input v-model.trim="loginForm.username" type="text" name="username" autocomplete="on" placeholder="请输入账号">
      <input v-model.trim="loginForm.password" type="password" name="password" placeholder="请输入密码" @keyup.enter="handleLogin">
      <div class="login-btn" @click="handleLogin">
        登录
      </div>
    </div>

  </div> -->
  <login-bg>
    <login-form />
  </login-bg>
</template>

<script>

// import md5 from 'js-md5'
// import {reg, checkReg} from '@/utils/RegExp'
import loginBg from './components/bg'
import loginForm from './components/loginFrom'
export default {
  name: 'Login',
  components:{
    loginBg,
    loginForm
  },

}
</script>


